import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import type { SignInPageProps } from '@backstage/plugin-app-react';
import { SignInScreen } from './SignInScreen';

/**
 * Sign-in page. Google is the only real provider; who may actually sign in is
 * decided on the backend against `auth.allowedDomains` and `auth.allowedUsers`,
 * not here — a button on this page grants nothing on its own.
 *
 * The guest button is offered only outside production, mirroring the backend:
 * the guest provider refuses to issue a token when `NODE_ENV !== 'development'`
 * unless `dangerouslyAllowOutsideDevelopment` is set, and the production config
 * does not set it. `auth.environment` is the signal because it is already
 * frontend-visible and already selects which `auth.providers.google.<env>`
 * block the OAuth flow uses, so the button and the flow cannot drift apart.
 */
function UzumSignInPage(props: SignInPageProps) {
  const configApi = useApi(configApiRef);
  const environment =
    configApi.getOptionalString('auth.environment') ?? 'development';

  return (
    <SignInScreen {...props} allowGuest={environment === 'development'} />
  );
}

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => UzumSignInPage,
      },
    }),
  ],
});
